import React, { useEffect } from 'react';
import Confetti from 'react-canvas-confetti';

import { CreateTypes, Options } from 'canvas-confetti';

import './SuccessConfetti.scss';

const CONFETTI_CONFIG: Options = {
    disableForReducedMotion: true,
    spread: 90,
    ticks: 300,
    gravity: 1.0,
    decay: 0.94,
    startVelocity: 30,
    scalar: 1.5,
    colors: [
        '#dc79aa',
        '#ea976b',
        '#f1bd64',
        '#bfdf76',
        '#7bdab4',
        '#76d1df',
        '#79acdc',
        '#9380d5',
        '#ca7fd6',
        '#7c9d96',
    ],
    particleCount: 60,
    shapes: ['circle', 'square'],
};

const SuccessConfetti = ({ active }: { active: boolean }) => {
    const ref = React.useRef<CreateTypes>();

    const fire = () => {
        if (!ref.current) return;

        ref.current({
            ...CONFETTI_CONFIG,
            angle: 120,
            origin: {
                x: 1,
                y: 1,
            },
        });

        ref.current({
            ...CONFETTI_CONFIG,
            angle: 60,
            origin: {
                x: 0,
                y: 1,
            },
        });
    };

    useEffect(() => {
        if (active) {
            fire();
        }
    }, [active]);

    return (
        <Confetti
            className="SuccessConfetti"
            onInit={({ confetti }) => {
                ref.current = confetti;
            }}
        />
    );
};

export default SuccessConfetti;
